export default "/images/6328cae132d3c3e97e8d504e840f5d29.avif";